<template>
  <div class=" mt-2">
    <b-breadcrumb class="breadcrumb-pipes">
      <b-breadcrumb-item href="/settings/admin-panel/">
        Admin Panel
      </b-breadcrumb-item>
      <b-breadcrumb-item href="/settings/user-role">
        Roles and Permissions
      </b-breadcrumb-item>
      <b-breadcrumb-item href="/settings/personal-settings">
        Personal Settings
      </b-breadcrumb-item>
    </b-breadcrumb>
    <b-card
      class="mb-0"
      :title="$t('settings.acting_capacity.titles.manage_acting_capacity')"
    >
      <b-overlay :show="loading" rounded="sm" no-fade>
        <div class="m-2">
          <b-row align-h="between">
            <b-col cols="12" md="3">
              <b-form-input
                v-model="filter"
                class="d-inline-block mr-1"
                :placeholder="$t('general_text.search_table')"
              />
            </b-col>

            <b-col v-if="$Can('add_acting_capacity')" cols="12" md="3">
              <div class="d-flex align-items-center justify-content-end">
                <b-button variant="success" @click="addActingCapacity">
                  <span class="text-nowrap">{{
                    $t(
                      "settings.acting_capacity.buttons.create_new_acting_capacity"
                    )
                  }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
          striped
          hover
          ref="refActingCapacity"
          class="position-relative p-2"
          :items="allActingCapacities"
          :filter="filter"
          filter-debounce="250"
          @filtered="onFiltered"
          :filter-included-fields="filterOn"
          selectable
          select-mode="single"
          responsive
          :small="true"
          head-variant="dark"
          :fields="tableColumns"
          show-empty
          :empty-text="$t('general_messages.no_matching_recors_found')"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template #cell(index)="data">
            <b
              ><span class="font-weight-bold">
                <strong class="text-primary">#{{ data.index + 1 }}</strong>
              </span></b
            >
          </template>
          <!-- Column: Acting Capacity -->
          <template #cell(ActingCapacity)="data">
            <b
              ><span class="font-weight-bold">
                <strong>{{
                  data.item.ActingCapacity ? data.item.ActingCapacity : "N/A"
                }}</strong>
              </span></b
            >
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item
                v-if="
                  $Can('edit_acting_capacity') ||
                    loggedUserRole == 'supermanager'
                "
                @click="updateActingCapacity(data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">
                  {{ $t("settings.acting_capacity.buttons.update") }}</span
                >
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("general_text.showing") }} {{ dataMeta.from }}
                {{ $t("general_text.to") }} {{ dataMeta.to }}
                {{ $t("general_text.of") }} {{ dataMeta.of }}
                {{ $t("general_text.entries") }}</span
              >
            </b-col>

            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
      {{ /*acting_capacity form modal*/ }}
      <b-modal
        id="modal-prevent-closing"
        v-model="actingCapacityFormModal"
        :title="$t('settings.acting_capacity.titles.acting_capacity_form')"
        @hidden="resetActingCapacityFormModal"
        size="md"
        :ok-title="
          status === 'create'
            ? $t('settings.acting_capacity.buttons.create')
            : $t('settings.acting_capacity.buttons.update')
        "
        :cancel-title="$t('settings.acting_capacity.buttons.cancel')"
        @ok="actingCapacityOprFunc"
        no-close-on-backdrop
      >
        <b-overlay :show="formLoading" rounded="sm" no-fade>
          <b-container>
            <b-form>
              <validation-observer ref="formValidation">
                <b-row class="mt-2">
                  <b-col cols="12" xl="12" md="12">
                    <!-- acting_capacity name -->
                    <b-form-group>
                      <validation-provider
                        #default="{ errors }"
                        :name="
                          $t(
                            'settings.acting_capacity.titles.acting_capacity_name'
                          )
                        "
                        rules="required|min:3"
                      >
                        <b-form-input
                          id="capacity_name"
                          v-model="actingCapacityName"
                          name="acting_capacity-name"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="
                            $t(
                              'settings.acting_capacity.titles.acting_capacity_name'
                            )
                          "
                          autofocus
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </validation-observer>
            </b-form>
          </b-container>
          <template #overlay v-if="formLoading">
            <div
              class="text-center d-flex justify-content-center align-items-start"
            >
              <b-icon icon="stopwatch" font-scale="3" animation="cylon">
              </b-icon>
              <p id="cancel-label">
                <feather-icon icon="DownloadIcon" />
                {{
                  $t(
                    "settings.acting_capacity.messages.acting_capacity_creating_message"
                  )
                }}
              </p>
            </div>
          </template>
        </b-overlay>
        {{/****END*** acting_capacity form modal*/}}
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormRating,
  VBModal,
  BTabs,
  BTab,
  BCardText,
  BIcon,
} from "bootstrap-vue";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../../settingsStoreModule";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, alphaNum, email, min, max } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import axios from "axios";
import axiosIns from "@/libs/axios";
import router from "@/router";
import moment from "moment";
import "animate.css";
import _ from "lodash";
import { mapState, mapGetters } from "vuex";
import { BBreadcrumb, BBreadcrumbItem } from "bootstrap-vue";

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BTabs,
    BTab,
    BCardText,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormRating,
    BIcon,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
    BBreadcrumb,
    BBreadcrumbItem,
  },

  directives: {
    Ripple,
    "b-modal": VBModal,
  },

  setup() {
    const SETTINGS_APP_STORE_MODULE_NAME = "settings";
    // Register module
    if (!store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
      store.registerModule(SETTINGS_APP_STORE_MODULE_NAME, settingsStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SETTINGS_APP_STORE_MODULE_NAME))
        store.unregisterModule(SETTINGS_APP_STORE_MODULE_NAME);
    });
  },

  data() {
    return {
      loggedUserRole: JSON.parse(localStorage.getItem("userData")).role,
      allActingCapacities: [],
      status: "",
      actingCapacityId: null,
      oldActingCapacityName: "",

      updateDefaultModal: false,
      updateDefaultLoading: false,
      equityDefault: null,
      bondDefault: null,
      fxDefault: null,
      transferDefault: null,
      fxOptionsDefault: null,
      futureContractDefault: null,
      optEquityDefaults: [],
      optBondDefaults: [],
      optFXDefaults: [],
      optTransferDefaults: [],
      optFxOptionsDefaults: [],
      optFutureContractDefaults: [],

      actingCapacityFormModal: false,
      formLoading: false,
      actingCapacityName: null,

      filterOn: ["ActingCapacity"],
      tableColumns: [
        {
          key: "index",
          label: "",
        },
        {
          key: "ActingCapacity",
          label: this.$t("settings.acting_capacity.table.acting_capacity_name"),
          sortable: true,
        },
        {
          key: "actions",
          label: this.$t("settings.acting_capacity.table.actions"),
          sortable: false,
        },
      ],
      perPage: localStorage.getItem("actingCapacityShow") ?? 10,
      currentPage: 1,
      totalRows: 0,
      perPageOptions: [10, 25, 50, 100],
      filter: null,

      loading: false,
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.getters["authUser"];
      },
      set(newValue) {
        return this.$store.dispatch("setUser", newValue);
      },
    },
    ...mapGetters(["authUser"]),
    dataMeta() {
      return {
        from:
          this.totalRows != 0 ? this.perPage * (this.currentPage - 1) + 1 : 0,
        to:
          this.perPage * (this.currentPage - 1) + Number(this.perPage) <
          this.totalRows
            ? this.perPage * (this.currentPage - 1) + Number(this.perPage)
            : this.totalRows,
        of: this.totalRows,
      };
    },
  },
  mounted() {
    this.getAllActingCapacities();
  },
  methods: {
    getAllActingCapacities() {
      this.loading = true;
      store
        .dispatch("settings/getActingCapacities")
        .then((res) => {
          this.allActingCapacities = res.data;
          this.totalRows = res.data.length;
          this.loading = false;
        })
        .catch((error) => {
          this.databaseErrorMessage();
          console.log(error);
        });
    },
    async addActingCapacity() {
      this.actingCapacityFormModal = true;
      this.status = "create";
    },
    actingCapacityOprFunc(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.formValidation.validate().then((success) => {
        if (success) {
          if (
            this.status == "Edit" &&
            this.oldActingCapacityTitle.toUpperCase() ==
              this.actingCapacityName.toUpperCase()
          ) {
            this.wrongToastMessage(
              this.$t("settings.acting_capacity.messages.same_acting_capacity")
            );
            return;
          }

          this.formLoading = true;

          const url =
            this.status == "create"
              ? "createNewActingCapacity"
              : "updateActingCapacity";
          const obj = {
            actingCapacity: _.startCase(_.toLower(this.actingCapacityName)),
          };
          if (this.status === "Edit") {
            obj.id = this.actingCapacityId;
          }

          store
            .dispatch(`settings/${url}`, obj)
            .then((res) => {
              if (res.data.status) {
                this.formLoading = false;
                this.resetActingCapacityFormModal();
                this.getAllActingCapacities();
                if (this.status == "create") {
                  this.successMessage(
                    this.$t(
                      "settings.acting_capacity.messages.acting_capacity_create_success"
                    )
                  );
                } else {
                  this.successMessage(
                    this.$t(
                      "settings.acting_capacity.messages.acting_capacity_update_success"
                    )
                  );
                }
              } else {
                this.wrongToastMessage(res.data.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    resetActingCapacityFormModal() {
      this.actingCapacityFormModal = false;
      this.actingCapacityName = null;
      this.formLoading = false;
      this.oldActingCapacityTitle = "";
      this.status = "";
    },
    async updateActingCapacity(data) {
      this.status = "Edit";
      this.actingCapacityId = data.id;
      this.oldActingCapacityTitle = data.ActingCapacity;
      this.actingCapacityName = data.ActingCapacity;
      this.actingCapacityFormModal = true;
    },
    deleteActingCapacity(acting_capacity) {
      const self = this;

      this.$swal({
        title:
          this.$t("settings.acting_capacity.titles.are_you_sure_delete") +
          ` ${acting_capacity.AccountName}`,
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t(
          "settings.acting_capacity.buttons.yes_delete_it"
        ),
        cancelButtonText: this.$t("settings.acting_capacity.buttons.cancel"),
        customClass: {
          confirmButton: "btn btn-success mr-1",
          cancelButton: "btn btn-danger",
          denyButton: "btn btn-primary",
        },
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          self.loading = true;
          store
            .dispatch("settings/deleteActingCapacity", {
              user: this.user,
              acting_capacity: acting_capacity.AccountName,
            })
            .then((res) => {
              if (res.data.info == true) {
                self.getAllActingCapacities();
                self.loading = false;
                self.$swal.fire({
                  icon: "success",
                  title: self.$t("settings.acting_capacity.titles.deleted"),
                  text: self.$t(
                    "settings.acting_capacity.messages.acting_capacity_has_been_delete"
                  ),
                  showClass: {
                    popup: "animate__animated animate__fadeInDown",
                  },
                });
              } else {
                this.actingCapacityNotFoundMessage();
                self.loading = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },

    databaseErrorMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t("settings.acting_capacity.messages.database_error"),
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    },
    existingCapacityMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t(
            "settings.acting_capacity.messages.acting_capacity_is_exist"
          ),
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    actingCapacityNotFoundMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: this.$t(
            "settings.acting_capacity.messages.acting_capacity_not_found"
          ),
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    successMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Successfully",
          text: val,
          icon: "ThumbsUpIcon",
          variant: "success",
        },
      });
    },
    wrongToastMessage(val) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Warning",
          text: val,
          icon: "AlertTriangleIcon",
          variant: "warning",
        },
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  watch: {
    perPage: {
      handler: function(val, before) {
        localStorage.setItem("actingCapacityShow", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
